import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DataTableColumn, PaginatorStatus, SortConfiguration } from '../../generics/data-table/data-table.component';
import { CustomTableFilter } from '../../generics/table-filter/table-filter.component';
import { ErrorResponse } from 'src/app/models/error.model';
import { MedioPagoCalculadora } from 'src/app/models/medio-pago-calculadora.model';
import { MediosPagoCalculadoraService } from 'src/app/services/medios-pago-calculadora.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-medios-pago',
    templateUrl: './medios-pago.component.html',
    styleUrls: ['./medios-pago.component.scss']
})
export class MediosPagoComponent implements OnInit {

    @ViewChild('ivaColumnTemplate', { static: true })
    ivaColumnTemplate: TemplateRef<any>;

    @ViewChild('costoIntColumnTemplate', { static: true })
    costoIntColumnTemplate: TemplateRef<any>;

    @ViewChild('activoColumnTemplate', { static: true })
    activoColumnTemplate!: TemplateRef<any>;

    @ViewChild('actionsColumnTemplate', { static: true })
    actionsColumnTemplate!: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'Nombre', prop: 'nombre', sortable: true },
        { name: 'Clave', prop: 'clave', width: '120px' },
        { name: 'Cuotas', prop: 'cuotas', width: '80px' },
        { name: 'Coef. ajuste', prop: 'coeficienteAjuste', width: '110px' },
        { name: 'Costo cobro', prop: 'costoCobro', width: '110px', parseValue: (v: number) => `${v}%` },
        { name: 'IVA', width: '80px' },
        { name: 'SIRTAC', prop: 'sirtac', width: '80px', parseValue: (v: number) => `${v}%` },
        { name: 'IIBB', prop: 'iibb', width: '80px', parseValue: (v: number) => `${v}%` },
        { name: 'C y D', prop: 'cyd', width: '80px', parseValue: (v: number) => `${v}%` },
        { name: 'Costo fin.', width: '100px' },
        { name: 'Estado', width: '90px' },
        { name: '', width: '90px' }
    ];

    sortConfiguration?: SortConfiguration;
    mediosPago: MedioPagoCalculadora[] = [];

    filters: CustomTableFilter[] = [
        { key: 'nombre', description: 'Nombre', type: 'STRING' }
    ];
    filterValues: any = {};

    constructor(
        private mediosPagoService: MediosPagoCalculadoraService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.columns.find(col => col.name === 'IVA').template = this.ivaColumnTemplate;
        this.columns.find(col => col.name === 'Costo fin.').template = this.costoIntColumnTemplate;
        this.columns.find(col => col.name === 'Estado').template = this.activoColumnTemplate;
        this.columns.find(col => col.name === '').template = this.actionsColumnTemplate;
        this.getMediosPago();
    }

    getMediosPago() {
        this.mediosPagoService.getMediosPago(
            this.paginatorStatus.page,
            this.paginatorStatus.itemsPerPage,
            this.sortConfiguration ? [this.sortConfiguration] : [],
            this.filterValues
        ).subscribe({
            next: response => {
                this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
                this.mediosPago = response.body ?? [];
            },
            error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener medios de pago', error.error?.descripcion ?? '')
        });
    }

    updatePage(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getMediosPago();
    }

    updateSort(event: SortConfiguration) {
        this.sortConfiguration = event;
        this.getMediosPago();
    }

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getMediosPago();
    }

    deleteMedioPago(medio: MedioPagoCalculadora) {
        const dialog = this.utilsService.confirm(
            '¿Dar de baja este medio de pago?',
            `"${medio.nombre}" quedará inactivo y no podrá seleccionarse en nuevas cotizaciones.`
        );
        dialog.afterClosed().subscribe(confirmed => {
            if (confirmed) {
                this.mediosPagoService.deleteMedioPago(medio.id!).subscribe({
                    next: () => {
                        this.utilsService.alert('Medio de pago dado de baja', `"${medio.nombre}" fue dado de baja correctamente.`);
                        this.getMediosPago();
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al dar de baja', error.error?.descripcion ?? '')
                });
            }
        });
    }
}
